import type { FieldValues, Path } from 'react-hook-form';
import TextInput, { TextInputProps } from './Forms/TextInput';
import FormComponent, { FormProps } from './Forms/Form';
import FormDropdown from './Forms/Dropdown';
import { DropdownProps } from './Forms/Dropdown/DropdownProps';

type TypedName<T extends FieldValues> = { name: Path<T> };

class InputFactory<T extends FieldValues> {
  Text = (props: TextInputProps<T> & TypedName<T>) => (
    <TextInput {...(props as TextInputProps)} />
  );
}

export type FormFactoryProps<T extends FieldValues> = FormProps<T>;

export default class FormFactory<T extends FieldValues> {
  Input = new InputFactory<T>();

  Dropdown = (props: DropdownProps & TypedName<T>) => (
    <FormDropdown {...props} />
  );

  constructor(
    private defaultProps?: { formRef?: FormFactoryProps<T>['formRef'] }
  ) {}

  Form = (props: FormFactoryProps<T>) => (
    <FormComponent {...this.defaultProps} {...props} />
  );
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export type IFormFactory<T> = FormFactory<T>;
